module.exports = __webpack_public_path__ + "img/bg.0a1f2ff3.png";